<template>
  <Modal :id="'cmp-multi-order-list'" @cancelled="onCancel">
    <template slot="header">{{ $t('multi_orders') }}</template>

    <template slot="body">
        <p>{{ $t('notify_process_complete') }}</p>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click="onCancel">{{$t('cancel')}}</button>
      <!-- <button class="dt-button v1  s6" @click="onAddMultiOrderClicked">
        Account All Orders
      </button> -->

      
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as orderActionTypes from "../../store/orders/types";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";
import InputField from "../../../../plugins/text-field/input-field";
import Checkbox2 from "../../../../plugins/checkbox/checkbox-2";
import { waitForAnimation, subscribeSubject } from "../../../../utility";
import Modal from "../../../../dt-plugins/modal/modal";
import { createModalMixin, closeModal2Route, openModal2Route } from "../../../../dt-plugins/modal/modal.mixin";
import { async } from "rxjs/internal/scheduler/async";
import NTable from "@/plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../../../dt-plugins/notification/notification.service';
export default {
  components: {
    InputField,
    Checkbox2,
    Modal,
    NTable,
  },

  mounted:async function() {
    //   const resData = await OrderService.getMultiOrders();

    //   this.accountList=resData
    //   this.statusList=resData.data.statuses.map(e=>{   return { text:e.value,value:e.textkey } }) 
    //   this.orderList=resData.data.orders
    //   this.moneyAccountList=resData.data.money_accounts.map(e=>{ return { text:e.money_account_name ,value:e.money_account_id } })

    //   console.log(resData)
  },
  watch: {},
  data: function () {
    return {

    };
  },
  // created: function () {
  //   this[orderActionTypes.FETCH_MULTI_ORDER_DATA]();
  // },

  computed: {

  },
  methods: {
    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.dt-modal--body {
  margin-left: 0px;
}

.contact-search {
  height: 30px;
  width: 100%;
  .search {
    margin-right: 10px;
    width: 250px;
  }
  .users-dropdown {
    width: 250px;
  }
}

.cm-multi-order-list-container {
  .multi-order-list {
    --ntable-height: 300px !important;
    --tb-layout: fixed;
    tr {
      padding-left: 5px;
    }
    td:last-child,
    th:last-child {
      width: 50px !important;
    }

    td.name {
      color: black !important;
      font-weight: 800 !important;
    }
  }

  .dt-table.ind-table {
    td:nth-child(5),
    th:nth-child(5) {
      width: 50px !important;
    }
  }
}
.contact-search {
  display: flex;
  margin: 20px;
  // flex-direction: row;
  // justify-content: stretch;
}
.fc2-checkbox {
  .dt-checkbox-container {
    .dt-checkbox {
      margin-top: 12px !important;
    }
  }
}

button {
  height: 2.5em;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  border-radius: 5px;
}
</style>
